/**
 * Esiur management error codes (C# `ExceptionCode : ushort`).
 * Numeric values are wire-significant — keep order in sync with the C# enum.
 */
export enum ExceptionCode {
  RuntimeException = 0,
  HostNotReachable,
  AccessDenied,
  UserOrTokenNotFound,
  ChallengeFailed,
  ResourceNotFound,
  AttachDenied,
  InvalidMethod,
  InvokeDenied,
  CreateDenied,
  AddParentDenied,
  AddChildDenied,
  ViewAttributeDenied,
  UpdateAttributeDenied,
  StoreNotFound,
  ParentNotFound,
  ChildNotFound,
  ResourceIsNotStore,
  DeleteDenied,
  DeleteFailed,
  UpdateAttributeFailed,
  GetAttributesFailed,
  ClearAttributesFailed,
  TypeDefNotFound,
  RenameDenied,
  ClassNotFound,
  MethodNotFound,
  PropertyNotFound,
  SetPropertyDenied,
  ReadOnlyProperty,
  GeneralFailure,
  AddToStoreFailed,
  NotAttached,
  AlreadyListened,
  AlreadyUnsubscribed,
  NotSubscribable,
  ParseError,
  Timeout,
  NotSupported,
  NotImplemented,
  NotAllowed,
}
